var EHDI = EHDI || Object.create(null);

EHDI.manager = EHDI.manager || Object.create(null);

EHDI.manager.PauseManager = function() {
    this.isPaused = false;
    
    var _this = this,
        _timelineArray = [],
        _autoresume = true;
    
    this.isReadyOpen = false;
    
    this.pauseGame = function() {
        if(_autoresume) {
            _autoresume = false;    
            EHDI.GAME.soundManager.autoResumeToggle(false);
        }
        if(_this.isPaused)
            return;
        _this.isPaused = true;
        
        for(var i = 0; i < _timelineArray.length; i++) {
            _timelineArray[i].paused(true);
        }
        
        EHDI.GAME.achieveManager.pauseAchievementNotif( true );
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(- EHDI.screen.stageHeight, 0), duration : 0.25});
        EHDI.GAME.soundManager.pauseBGM();
        EHDI.GAME.soundManager.pauseAllSFX();
        
    }
    
    var checkInterrupt = function() {
        if(window.document.webkitHidden || window.document.hidden) {
            _this.pauseGame();
        }
    }

    window.addEventListener("blur", this.pauseGame);
    window.addEventListener("pagehide", this.pauseGame);
    window.addEventListener("webkitvisibilitychange", checkInterrupt);
    window.addEventListener("visibilitychange", checkInterrupt);
    
    this.resumeGame = function() {
        if(_this.isReadyOpen)
            return;
        _this.isPaused = false;
        
        var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
        if( !cache.isMuted ){
            EHDI.GAME.soundManager.resumeBGM();
            EHDI.GAME.soundManager.resumeAllSFX();
        }
        
        for(var i = 0; i < _timelineArray.length; i++) {
            _timelineArray[i].paused(false);
        }
        
        EHDI.GAME.achieveManager.pauseAchievementNotif( false );
    }
    
    this.readyPopUp = function( type, common, uncommon, rare ) {
        _this.isPaused = true;
        _this.isReadyOpen = true;
        for(var i = 0; i < _timelineArray.length; i++) {
            _timelineArray[i].paused(true);
        }
        EHDI.GAME.sceneManager.pushPopUp( new EHDI.popup.CatchlistPopup( type, common, uncommon, rare ) );
        EHDI.GAME.soundManager.pauseAllSFX();
    }
    
    this.endGame = function() {
        window.removeEventListener("blur", this.pauseGame);
        window.removeEventListener("pagehide", this.pauseGame);
        window.removeEventListener("webkitvisibilitychange", checkInterrupt);
        window.removeEventListener("visibilitychange", checkInterrupt);
        EHDI.GAME.soundManager.autoResumeToggle(true);
    }
    
    this.addTimelineInterrupt = function(timeline) {
        _timelineArray.push(timeline);
    }
    
    this.removeTimelineInterrupt = function(timeline) {
        var index = _timelineArray.indexOf(timeline);
        if(index > -1) 
            _timelineArray.splice(index, 1);
    }
}

EHDI.manager.PauseManager.prototype = Object.create(null);